import type {FullInfo} from '@rocket-ui/lk-api';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

type FullInfoCheck = (fullInfo: FullInfo) => boolean;

function hasNonEmptyString(value: unknown): value is string {
	return typeof value === 'string' && value.trim().length > 0;
}

function getResidence(fullInfo: FullInfo): {oksmCode?: string | null} | null {
	const {residence} = fullInfo;

	if (!residence || typeof residence !== 'object') {
		return null;
	}

	return residence as {oksmCode?: string | null};
}

/** Проверки полей info — обязательны для всех пользователей. */
const INFO_CHECKS: FullInfoCheck[] = [
	(fullInfo) => hasNonEmptyString(fullInfo.info?.firstName),
	(fullInfo) => hasNonEmptyString(fullInfo.info?.secondName),
	(fullInfo) => {
		const email = fullInfo.info?.email;

		if (!hasNonEmptyString(email)) {
			return false;
		}

		return EMAIL_PATTERN.test(email.trim());
	},
];

/** Проверки residence — обязательны для всех пользователей. */
const RESIDENCE_CHECKS: FullInfoCheck[] = [(fullInfo) => hasNonEmptyString(getResidence(fullInfo)?.oksmCode)];

/**
 * Список проверок полноты профиля. Добавляйте новые проверки в соответствующую группу
 * или расширяйте этот массив.
 */
export const FULL_INFO_COMPLETENESS_CHECKS: FullInfoCheck[] = [...INFO_CHECKS, ...RESIDENCE_CHECKS];

export function isFullInfoComplete(fullInfo: unknown): boolean {
	if (!fullInfo || typeof fullInfo !== 'object') {
		return false;
	}

	return FULL_INFO_COMPLETENESS_CHECKS.every((check) => check(fullInfo as FullInfo));
}
